export default __webpack_public_path__ + "static/media/starsCL.13a29ab1.webp";